// To generate a new file similar to this one, run `pay js:run gql-v1 --type=mutation --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

import type {
  V1MutationOptions,
  V1MutationOptionsWithoutVariables,
  V1MutationReturn,
  AccountToken,
} from '@stripe-internal/data-v1/types';
/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';
import {useV1Mutation} from '@stripe-internal/data-v1';

import type {
  GraphQlDocument,
  GraphQlFragmentUnion,
  HookVariables,
} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1CryptoInternalPayinSessionUpdateInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';
import {payinSessionFragment} from 'src/api/graphql/payinSessionFragment';

import type {
  PayinSessionFragmentData,
  PayinSessionFragmentToken,
} from 'src/api/graphql/payinSessionFragment';

const doc = gql`
  mutation UpdatePayinSessionMutation(
    $input: OpenapiPostV1CryptoInternalPayinSessionUpdateInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalPayinSessionUpdate(input: $input, v1Context: $v1Context) {
      id
      ...PayinSessionFragment
    }
  }
  ${payinSessionFragment}
`;

export const updatePayinSessionMutation: UpdatePayinSessionMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const updatePayinSessionMutationOptions: V1MutationOptionsWithoutVariables<UpdatePayinSessionMutationDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function useUpdatePayinSessionMutation<
  THookVariables extends HookVariables<UpdatePayinSessionMutationVariables> = {},
>(
  options: V1MutationOptions<
    UpdatePayinSessionMutationDocument,
    THookVariables
  > = {},
): V1MutationReturn<UpdatePayinSessionMutationDocument, THookVariables> {
  return useV1Mutation(updatePayinSessionMutation, {
    ...updatePayinSessionMutationOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type UpdatePayinSessionMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1CryptoInternalPayinSessionUpdateInput>;
  v1Context: V1ContextInput;
}>;

export type UpdatePayinSessionMutationData = {
  readonly __typename: 'Mutation';
  readonly v1CryptoInternalPayinSessionUpdate: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoPayinSession';
      readonly id: string;
    },
    [PayinSessionFragmentData]
  > | null;
};

export type UpdatePayinSessionMutationToken = PayinSessionFragmentToken &
  AccountToken<{Mutation_v1CryptoInternalPayinSessionUpdate: true}>;

export type UpdatePayinSessionMutationDocument = GraphQlDocument<
  UpdatePayinSessionMutationData,
  UpdatePayinSessionMutationVariables,
  UpdatePayinSessionMutationToken
>;
